import React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import type { CardHeaderProps } from '@mui/material/CardHeader';

// 卡片
export default function CardView(props: {
    // 卡片标题
    title?: string | JSX.Element;
    // 按钮
    actionRender?: JSX.Element;
    // 内容
    contentRender?: JSX.Element;
    contentClassName?: string;
    className?: string;
    /** 与 CardHeader 标题 Typography 一致，避免与泛型 TypographyProps 冲突 */
    titleTypographyProps?: CardHeaderProps['titleTypographyProps'];
    style?: React.CSSProperties;
}) {
    const { title, actionRender, contentRender, contentClassName, className, titleTypographyProps, style } = props;
    return (
        <Card className={className} style={style}>
            {
                title &&
                <CardHeader
                    action={actionRender}
                    title={title}
                    titleTypographyProps={titleTypographyProps}
                />
            }
            <CardContent className={contentClassName ?? ''}>
                {contentRender}
            </CardContent>

        </Card>
    )
}